<template>
  <Transition name="fade">
    <div v-show="show" class="fixed z-10 inset-0 overflow-y-auto w-screen h-screen top-none left-none" aria-labelledby="modal-title" role="dialog" aria-modal="true">
      <div class="flex items-end justify-center min-h-screen pt-4 pb-20 mx-4 text-center sm:block sm:p-0">
        <Transition name="fade">
          <div v-if="show" class="modal-background fixed inset-0 bg-black w-screen h-screen bg-opacity-70 transition-opacity ease duration-200" aria-hidden="true" @click="handleOutsideClick"></div>
        </Transition>
        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

        <Transition name="zoom">
          <div v-if="show" class="modal-box inline-block bg-white rounded-9 text-left shadow-modalBox transform transition-all my-lg sm:align-middle sm:max-w-2xl lg:w-modal w-full sm:w-fullMargin" ref="modalBox" @keyup.esc="$emit('close', $event);">
            <TWLoadingSpinner v-if="loading" />

            <h3
              v-if="!!title"
              class="modal-title text-24 text-left leading-6 font-medium break-all mb-none p-base border-0 border-b-1 border-solid"
            >
              {{ title }}
            </h3>

            <div class="modal-contents text-left p-base">
              <slot name="content" />
            </div>

            <div
              v-if="!!$slots.controls"
              class="modal-controls w-full flex flex-col-reverse justify-end content-end gap-base mt-none p-base pt-5 sm:flex-row border-0 border-t-1 border-solid"
            >
              <slot name="controls" />
            </div>

            <button @click="$emit('close');" type="button" class="tw-close">
              <span class="sr-only">{{ $t('functional.close') }}</span>
              <XMarkIcon />
            </button>
          </div>
        </Transition>
      </div>
    </div>
  </Transition>
</template>
<script>
import TWLoadingSpinner from '@/components/tailwind/LoadingSpinner.vue';
import { XMarkIcon } from '@/components/icons/fontIcons';

export default {
  name: 'TWModal',
  components: {
    TWLoadingSpinner,
    XMarkIcon,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: undefined,
    },
    show: {
      type: Boolean,
      required: false,
      default: false,
    },
    autoFocus: {
      type: Boolean,
      required: false,
      default: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
    allowOutsideClickToClose: {
      type: Boolean,
      default: true,
    },
  },
  mounted() {
  },
  watch: {
    show(value) {
      if (value === true && this.autoFocus) {
        this.$nextTick(() => {
          this.$refs.modalBox.querySelector('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])').focus(); // Give focus to the first focusable element
        });
      }
    },
  },
  methods: {
    handleOutsideClick() {
      if (!this.allowOutsideClickToClose) return;

      this.$emit('close');
    },
  },
};
</script>

<style scoped>

.zoom-enter-active {
  animation: zoom-in .15s;
}
.zoom-leave-active {
  animation: zoom-in .15s reverse;
}

.fade-enter-active {
  animation: fade-in .15s;
}
.fade-leave-active {
  animation: fade-in .15s reverse;
}

@keyframes zoom-in {
  0% {
    transform: translateY(-50px) scale(0.8);
  }
  50% {
    transform: translateY(-30px) scale(0.9);
  }
  100% {
    transform: translateY(0px) scale(1);
  }
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.bg-white{
  background-color: #ffffff;
}
</style>
